import { Component, OnInit } from '@angular/core';
import { PromptService } from '../_services/prompt.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditpromptComponent } from './editprompt/editprompt.component';

@Component({
  selector: 'app-prompts',
  templateUrl: './prompts.component.html',
  styleUrls: ['./prompts.component.css']
})
export class PromptsComponent implements OnInit {

  constructor(private promptService:PromptService,private modal: NgbModal) { }
  labels:any[]=[];
  ngOnInit() {
    this.getPrompts();
  }


  getPrompts(){
      this.promptService.getPrompts().subscribe(res=>{
        this.labels=res;
      });
  }


  openEditModal(data:any){
    const modalref=  this.modal.open(EditpromptComponent, { size: 'lg' });
    modalref.componentInstance.label=data;
    modalref.result.then((result)=>{
      this.getPrompts();
    });
    }


}
